<script>
  import ColorPicker from "../../Common/ColorPicker.svelte";
  import { toolboxEnableGlobalControl } from "../global";
  import {M} from "../../external";

  export let data,
    disable = [],
    isCollapsable = false,
    isCollapsed = false;

  if (data && data.style) {
    data.style.backgroundColor = data.style.backgroundColor || "#ffffff";
  }

  function change(prop, value) {
    data.style = Object.assign({}, data.style, { [prop]: value });
  }
</script>

{#if disable.indexOf("blockGlobal") === -1 || !data.type}
  <div class="mt-15 col20 f-left email-styling-wrapper">
    {#if !data.isFullscreen || toolboxEnableGlobalControl(data.type)}
      <div class="col20 f-left color-pick-wrap-widgets">
        <ColorPicker bind:color={data.style.backgroundColor} label={M.BACKGROUND_COLOR} alpha="no" onChange={(color) => change("backgroundColor", color)} />
      </div>
    {/if}
  </div>
{/if}
